export const isChildNode = (target, parent) => {
  if (parent == null) {
    return false;
  }

  const parentNode = target.parentNode;
  if (parentNode == null) {
    return false;
  }
  if (parentNode === parent) {
    return true;
  }
  return isChildNode(parentNode, parent);
};

export const findParentNode = (target, check) => {
  for (;;) {
    const parentNode = target.parentNode;

    if (parentNode == null) {
      return null;
    }

    if (check(parentNode)) {
      return parentNode;
    }
    target = parentNode;
  }
};


